import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getInpcById as getById,
  resetForm as reset,
  modifyInpc as modify,
  addInpc as add,
  updateInpc as update,
} from 'inpc/actions';
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions';

import { getEditing } from 'inpc/selectors';
import { getCompany } from 'auth/selectors';

import { valueFromEvent } from 'lib/util';

class InpcFormHandlers extends Component {
  static propTypes = {
    render: Proptypes.func.isRequired,
  };

  state = { isSubmitted: false, isValid: false };

  handleValueChange = (e) => this.props.modify(valueFromEvent(e));

  handleValidation = (isValid) => this.setState({ isValid });

  handleSubmit = ({ isValid }) => {
    this.setState({ isSubmitted: true, isValid, isSaving: true }, () => {
      if (isValid) {
        const promise = this.props.inpc.id
          ? this.props.update(this.props.inpc.id, this.props.company.id, this.props.inpc)
          : this.props.add(this.props.company.id, this.props.inpc);

        promise
          .then(({ value }) => {
            this.props.success(value.message);
            this.props.history.push(`/companies/${this.props.company.id}/inpc`);
          })
          .catch((err) => {
            this.props.error(err.message);
            this.finishSaving();
          });
      } else {
        this.props.error('error.verify');
        this.finishSaving();
      }
    });
  };

  finishSaving() {
    this.setState({ isSaving: false });
  }

  componentWillMount = () => {
    const { iId } = this.props.match.params;
    this.props.reset();
    iId && this.props.getById(iId, this.props.company.id);
  };

  render = () =>
    this.props.render({
      isSaving: this.state.isSaving,
      isSubmitted: this.state.isSubmitted,
      handleSubmit: this.handleSubmit,
      handleValueChange: this.handleValueChange,
      handleValidation: this.handleValidation,
    });
}

const mapStateToProps = (state) => ({
  inpc: getEditing(state),
  company: getCompany(state),
});
const mapDispatchToProps = { reset, getById, modify, add, update, error, success };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InpcFormHandlers));



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/containers/InpcFormHandlers.js